import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useEffect, useRef, useState, useMemo } from "preact/hooks";
import { sortData } from "../helpers" 
import { filterMapping, sizesOrder } from "../config"

import Checkbox from "./elements/Checkbox"

export default function Facet({ facet }) {
    const { active, toggleActive, toggleProductFilter } = useFacet(facet);
    const contentRef = useRef(null);
    const [ height, setHeight ] = useState(0);
    const isColor = useMemo(() => facet.name.toLowerCase().trim() === "color" || facet.name.toLowerCase().trim() === "colour")
    const isSale = useMemo(() => facet.name.toLowerCase().trim() === 'sale', [])

    //if no products on sale, hide sale facet
    if(isSale && !facet.data?.find(d => d.value === 'true')) return null; 

    useEffect(() => {
        setHeight(active ? contentRef.current?.scrollHeight : 0)
    }, [ active ])

    return (
        <li class={`ns-facet-dropdown ${isColor ? 'ns-color-facet' : 'ns-checkbox-facet'}`}>
            <button 
                type="button"
                class="ns-facet-toggle ns-flex ns-items-center ns-justify-between ns-anchor ns-lg-hidden ns-w-100 ns-border-box"
                data-nosto-element="facet"
                onClick={toggleActive}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name} filters`}
                aria-expanded={!!active}
            >
                <span class="ns-facet-toggle-text">{facet.name}</span>
                <svg aria-hidden="true" focusable="false" role="presentation" width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6.57143 7.5L1 14" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <h3 class="ns-facet-title ns-hidden ns-lg-block">{facet.name}</h3>
            <div 
                class="ns-facet-body" 
                id={`${facet.id}-sub-menu`}
                aria-hidden={!active}
                ref={contentRef}
                style={{ height: `${height}px` }}
            >
                <ul class="ns-facet-list ns-list-unstyled ns-p-0 ns-m-0" role="menu">
                    {(facet.name.toLowerCase().trim() === 'size' ? sortData(facet.data, sizesOrder, (item) => item.value) : facet.data)?.map(value => (
                        <li
                            key={value.value}
                            class="ns-filter-item"
                            data-nosto-element="facet-setting"
                            role="menuitem"
                        >
                            {(!isSale || isSale && value.value === "true") && (
                                <Checkbox
                                    className="ns-flex ns-items-center"
                                    value={value.value}
                                    selected={value.selected}
                                    labelText={`${isSale && value.value === "true" ? "On Sale" : value.value} (${value.count})`}
                                    isColor={isColor}
                                    onChange={e => {
                                        e.preventDefault()
                                        toggleProductFilter(facet.field, value.value, !value.selected)
                                    }}
                                />
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
